import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'

import resourceInfo from 'shared/src/resource/info'
import resourcePrice from 'shared/src/resource/price'
import numberUtils from 'shared/src/utils/number'

const useStyles = makeStyles(theme => ({
  smallText: {
    fontSize: '0.8em',
    color: '#999'
  },
  boldText: {
    fontWeight: 'bold',
  },
}))

const LinkInfo = ({
  currency,
  resource,
  amount,
}) => {
  const classes = useStyles()

  if(!resourceInfo.isLinkBased(resource)) return null

  const price = resourcePrice({
    resource, 
    amount,
  })

  return (
    <div>
      {
        price.links.map((linkPrice, i) => {

          const link = linkPrice.link
          const resource = link.resource
          const priceMode = link.meta.price > 0

          const priceParts = [
            priceMode ? '' : numberUtils.twoDp(linkPrice.amount) + ' x ',
            resource.name,
            '=',
            currency,
            numberUtils.twoDp(linkPrice.price),
            '@',
            currency,
          ].filter(s => s)

          const unitParts = priceMode ?
            [
              linkPrice.base.price,
              '/',
              linkPrice.base.unit,
            ] :
            [
              linkPrice.base.price,
              '/',
              //linkPrice.base.amount == 1 ? '' : linkPrice.base.amount,
              linkPrice.base.unit// + (linkPrice.base.amount == 1 ? '' : 's'),
            ]

          return (
            <Typography
              key={ i }
              className={ classes.smallText }
            >
              • { priceParts.concat(unitParts).join(' ') }
            </Typography>
          )
        })
      }
    </div>
  )
}

LinkInfo.defaultProps = {
  amount: 1,
  unit: 'day',
}

export default LinkInfo

